// noinspection JSUnusedGlobalSymbols

import { authTokenSlice } from './authToken.slice.ts';

export const { setErrorMsg, setAuthCreds, setAuthToken, resetAuthToken, SET_JWT_TOKEN } =
  authTokenSlice.actions;
